import { render, staticRenderFns } from "./LoongLayout.vue?vue&type=template&id=271e5d8a"
import script from "./LoongLayout.vue?vue&type=script&lang=js"
export * from "./LoongLayout.vue?vue&type=script&lang=js"
import style0 from "./LoongLayout.vue?vue&type=style&index=0&id=271e5d8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports